module.exports = __webpack_public_path__ + "media/images/prize__xtr-pedals-40d314aa3bdefa0520de07413db1792e.jpg";